var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../converters/DateConverter";
export class Subscription {
  constructor(_data) {
    /**
     */
    __publicField(this, "Country");
    /**
     */
    __publicField(this, "CreatedAt");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IsEnabled");
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Subscription
     */
    __publicField(this, "$type", "V1.Cesop.Subscriptions.Subscription");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Country = _data["Country"];
      this.CreatedAt = DateConverter.from(_data["CreatedAt"]);
      this.Id = _data["Id"];
      this.IsEnabled = _data["IsEnabled"];
      this.Type = SubscriptionType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Country"] = this.Country;
    _data["CreatedAt"] = DateConverter.toUtcDateString(this.CreatedAt);
    _data["Id"] = this.Id;
    _data["IsEnabled"] = this.IsEnabled;
    _data["Type"] = SubscriptionType[this.Type];
    return _data;
  }
}
export var SubscriptionType = /* @__PURE__ */ ((SubscriptionType2) => {
  SubscriptionType2["FullCompliance"] = "FullCompliance";
  SubscriptionType2["SubmissionOnly"] = "SubmissionOnly";
  return SubscriptionType2;
})(SubscriptionType || {});
